import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance with default config
const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Important for session cookies
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor - no need to add token for session-based auth
axiosInstance.interceptors.request.use(
    (config) => {
        // With session-based auth, the cookie is automatically sent
        // No need to manually add authorization headers
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // Handle unauthorized access for any API request from our instance
        if (error.response?.status === 401) {
            // Don't redirect if we're already on a public page
            const publicPaths = ['/', '/login', '/register', '/forgot-password', '/news', '/faq'];
            const currentPath = window.location.pathname;
            const isPublicPath = publicPaths.some(path => 
                currentPath === path || currentPath.startsWith(`${path}/`)
            );
            
            // Only redirect if not on a public path
            if (!isPublicPath && currentPath !== '/login') {
                window.location.href = '/login';
            }
        }
        
        return Promise.reject(error);
    }
);

export default axiosInstance; 